import React, { useEffect, useState } from 'react';
import Header from '../Components/Header';
import Footer from '../Components/Footer';
import SAML from '../Components/SAML';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useIsAuthenticated } from '@azure/msal-react';

const Login = () => {
  const isAuthenticated = useIsAuthenticated();
  const navigate = useNavigate();

  const translations = useSelector(state => state.translationReducer);
  const [translation, setTranslation] = useState([]);
  

  useEffect(() => {
    setTranslation(translations.data);
  }, [translations]);

  return (
    <>
      <Header />
        <div className="container-fluid min-vh-100" style={{ backgroundImage: 'url(assets/img/degradado.png)', backgroundSize: 'cover', backgroundRepeat: 'no-repeat' }}>
          <div className="container">
            <div className="row justify-content-md-center">
              <div id="login-access" className="col-lg-6 align-self-center pt-5 px-2 my-5" data-aos="fade-up">
                <div className="float-start-50 px-5">
                  <h2 className="text-light" style={{ fontWeight: 600 }}>Iniciar sesión</h2>
                  <div className="d-grid">
                    <SAML className="btn btn-lg btn-primary my-5" />
                  </div>
                  <div style={{ textAlign: 'center' }} data-aos="fade-up" data-aos-delay={200}>
                  
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      <Footer />
    </>
  );
}

export default Login;